<template>
    <div class="eiList">
        <List ref="list" :orderByData="orderByData" :totalNum="totalNum">
            <template slot="list">
                <div v-for="(item, index) in list" :key="index" class="con">
                    <h4>
                        <router-link v-html="index + 1 + ' . ' + item.ti" :to="{ path: '/eiDetails', query: { url: item.url } }" class="homePan">
                        </router-link>
                    </h4>
                    <div>
                        <p>
                            作者:<span>{{ item.au }}</span>
                        </p>
                        <p>
                            来源:<span>{{ item.so }}</span>
                        </p>
                    </div>
                </div>
            </template>

            <template slot="listLeft">
                <van-collapse v-model="activeName" accordion>
                    <van-collapse-item v-for="(item, index) in facetList" :key="index" :title="item.name" :name="item.field">
                        <p style="text-align:center;padding: 10px 0;" v-show="shoeP">
                            暂无数据
                        </p>
                        <van-loading size="24px" v-show="shoeLo">加载中...</van-loading>
                        <van-radio-group v-model="facetRadio">
                            <van-radio
                                :name="item.field + (index1 + 1)"
                                v-for="(item1, index1) in item.list"
                                :key="index1"
                                @click="facetCickL(item.field, item1.label)"
                            >
                                {{ item1.label }}<span style="float: right;">({{ item1.value }})</span>
                            </van-radio>
                        </van-radio-group>
                    </van-collapse-item>
                </van-collapse>
            </template>
        </List>
    </div>
</template>
<script>
import api from "@/request/api/eiApi";
import List from "@/components/list.vue";
// import { Toast } from 'vant'
export default {
    data() {
        return {
            list: [], // 列表  1
            activeName: 0,
            page: 1,
            orderByData: [
                { title: "Relevance", value: "relevance|dw" },
                { title: "Date(Oldest)", value: "yr|up" },
                { title: "Date(Newest)", value: "yr|dw" },
                { title: "Author(A-Z)", value: "ausort|up", sort: "descending" },
                { title: "Author(Z-A)", value: "ausort|dw", sort: "ascending" },
                { title: "Source(A-Z)", value: "stsort|up", sort: "descending" },
                { title: "Source(Z-A)", value: "stsort|dw", sort: "ascending" },
                { title: "Publisher(A-Z)", value: "pnsort|up", sort: "descending" },
                { title: "Publisher(Z-A)", value: "pnsort|dw", sort: "ascending" }
            ], // 排序数据
            totalNum: 0, // 检索总数据
            facetList: [], // 分面数据
            shoeP: false, // 筛选暂无数据显示隐藏
            shoeLo: false, // 筛选加载中显示隐藏
            eiRefineData: {
                facetTerm: "",
                sortBy: "relevance|dw"
            }, // 分维度选择检索接口
            facetRadio: 0 //1
        };
    },
    components: {
        List
    },
    mounted() {
        this.search();
        this.$store.dispatch("actionsHead", { type: true, title: "Engineering Village", iconType: true });
    },
    methods: {
        search() {
            api.eiSearch(this.$route.query).then((res) => {
                this.list = res.data.list;
                this.totalNum = res.data.total;
                this.facetList = res.data.facetList;
            });
        },
        onLoad() {
            this.page = Number(this.page) + 1;
            var data = {
                page: this.page
            };
            this.$refs.list.onLoadShow = false;
            api.eiPage(data).then((res) => {
                this.$refs.list.listLoading = false;
                this.$refs.list.onLoadShow = true;
                if (res.code == 0) {
                    if (res.data.list.length == 0) {
                        this.$refs.list.listShow = true;
                    } else {
                        this.$refs.list.listShow = false;
                        this.list = this.list.concat(res.data.list);
                        this.totalNum = res.data.total;
                    }
                } else {
                    this.$refs.list.listShow = true;
                }
            });
        },
        facetCickL(field, label) {
            this.eiRefineData.facetTerm = field + "nav|" + label;
            this.eiRefine("left");
        },
        orderByCick(val) {
            if (this.eiRefineData.facetTerm != "") {
                this.eiRefineData.sortBy = val;
                this.$refs.list.listCurrent = val;
                this.eiRefine("right");
            } else {
                // Toast('左侧筛选不能为空!');
            }
        },
        eiRefine(val) {
            api.eiRefine(this.eiRefineData).then((res) => {
                this.$refs.list.listLoading = false;
                if (res.code == 0) {
                    if (res.data.list.length == 0) {
                        this.$refs.list.listShow = true;
                    } else {
                        this.$refs.list.listShow = false;
                        this.list = res.data.list;
                        this.totalNum = res.data.total;
                    }
                    if (val == "left") {
                        this.$refs.list.listLefShow = false;
                    } else if (val == "right") {
                        this.$refs.list.listRightShow = false;
                    }
                } else {
                    this.$refs.list.listShow = true;
                }
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "eiDetails") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>
<style lang="less">
// .eiList {
// }
.van-popup {
    .active {
        color: #09718b;
    }
}
</style>
